export const VALIDATE_EMAIL = 'providers/workforce/Email/VALIDATE_EMAIL';
